import { createContext, SetStateAction, useContext, useState } from "react";
import { GetTradeJumpInfoResponseModel } from "@/features/trade-jump/services/get-trade-jump-info-model";

interface TradeJumpContextType {
  tradeJumpMode: boolean;
  syncJump: boolean | undefined;
  jumpDetailSid?: string;
  jumpMlinkAccountId?: string;
  jumpMlinkId?: string;
  jumpStartDate?: string;
  jumpEndDate?: string;
  tradeJumpInfo?: GetTradeJumpInfoResponseModel;
  jumpFirstProcess: boolean;
  setTradeJumpMode: React.Dispatch<SetStateAction<boolean>>;
  setSyncJump: React.Dispatch<SetStateAction<boolean | undefined>>;
  setJumpDetailSid: React.Dispatch<SetStateAction<string | undefined>>;
  setJumpMlinkAccountId: React.Dispatch<SetStateAction<string | undefined>>;
  setJumpMlinkId: React.Dispatch<SetStateAction<string | undefined>>;
  setJumpStartDate: React.Dispatch<SetStateAction<string | undefined>>;
  setJumpEndDate: React.Dispatch<SetStateAction<string | undefined>>;
  setTradeJumpInfo: React.Dispatch<SetStateAction<GetTradeJumpInfoResponseModel | undefined>>;
  setJumpFirstProcess: React.Dispatch<SetStateAction<boolean>>;
}

const TradeJumpContext = createContext<TradeJumpContextType | undefined>(undefined);

export const TradeJumpProvider = ({children}: {children: React.ReactNode}) => {
  const [tradeJumpMode, setTradeJumpMode] = useState(false);
  const [syncJump, setSyncJump] = useState<boolean | undefined>(undefined);
  const [jumpDetailSid, setJumpDetailSid] = useState<string | undefined>(undefined);
  const [jumpMlinkAccountId, setJumpMlinkAccountId] = useState<string | undefined>(undefined);
  const [jumpMlinkId, setJumpMlinkId] = useState<string | undefined>(undefined);
  const [jumpStartDate, setJumpStartDate] = useState<string | undefined>(undefined);
  const [jumpEndDate, setJumpEndDate] = useState<string | undefined>(undefined);
  const [tradeJumpInfo, setTradeJumpInfo] = useState<GetTradeJumpInfoResponseModel | undefined>(undefined);
  const [jumpFirstProcess, setJumpFirstProcess] = useState<boolean>(true);

  const ch = new BroadcastChannel("app-events");
  ch.addEventListener('message', (ev) => {
    setSyncJump(ev.data.syncJump);
  });

  return (
    <TradeJumpContext.Provider
      value={{
        tradeJumpMode,
        syncJump,
        jumpDetailSid,
        jumpMlinkAccountId,
        jumpMlinkId,
        jumpStartDate,
        jumpEndDate,
        tradeJumpInfo,
        jumpFirstProcess,
        setTradeJumpMode,
        setSyncJump,
        setJumpDetailSid,
        setJumpMlinkAccountId,
        setJumpMlinkId,
        setJumpStartDate,
        setJumpEndDate,
        setTradeJumpInfo,
        setJumpFirstProcess,
      }}
    >
      {children}
    </TradeJumpContext.Provider>
  );
};

export const useTradeJumpContext = () => {
  const context = useContext(TradeJumpContext);
  if (!context) throw new Error("useTradeJumpContext must be used within TradeJumpProvider");
  return context;
};